// extracted by mini-css-extract-plugin
export default {"modal":"modalPage_modal__RPQM2","info":"modalPage_info__s3bjx","input":"modalPage_input__+Dgme","counts":"modalPage_counts__WOnRe","sub_btn":"modalPage_sub_btn__gH89i"};